var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrayReplay = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 15c-.413 0-.766-.118-1.06-.353-.294-.235-.44-.517-.44-.847V12h1.5v1.8h9V12H14v1.8c0 .33-.147.613-.441.848A1.64 1.64 0 0 1 12.5 15h-9zM7.024 2.938A1 1 0 0 0 5.5 3.79v4.42a1 1 0 0 0 1.524.852l3.592-2.21a1 1 0 0 0 0-1.704l-3.592-2.21z"
})));
export default SvgTrayReplay;